import { connect } from 'react-redux'
import PharmacyDetails from './PharmacyDetails'
import * as actions from '../../redux/organisations'

const mapStateToProps = (state) => ({
  organisation: state.organisations.organisation,
  fetching: state.organisations.fetching,
  tabValue: state.organisations.tabValue,
  mainTabValue: state.organisations.mainTabValue,
  page: state.organisations.page,
  filter: state.organisations.filter,
  orgID: state.authentication.orgID
})

export default connect(mapStateToProps, actions)(PharmacyDetails)
